import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { StreakFreezeSimpleIcon } from './icons/streak_freeze_simple_icon';
import { StreakFreezeEmptyIcon } from './icons/streak_freeze_empty_icon';
import { STREAK_FREEZE_STOCK_MAX } from '@lean-body/src/domain';
export const ActivityStreakFreezeStockCard = ({ classObject, freezeStock, onClick }) => {
    return (React.createElement("div", { className: css(styles.container, classObject), onClick: onClick },
        React.createElement("div", { className: css(styles.content) },
            React.createElement("div", { className: css(styles.label) }, "\u30D5\u30EA\u30FC\u30BA\u306E\u3053\u308A"),
            React.createElement("div", { className: css(styles.freezeStockContainer) }, Array.from({ length: STREAK_FREEZE_STOCK_MAX }).map((_, index) => index < freezeStock ? (React.createElement(StreakFreezeSimpleIcon, { key: index, classObject: styles.freezeIcon })) : (React.createElement(StreakFreezeEmptyIcon, { key: index, classObject: styles.freezeEmptyIcon })))))));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.White,
        padding: '12px 24px',
        borderRadius: 10,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        cursor: 'pointer',
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 6,
        width: '100%',
        [MediaBreakPointUp.XL]: {
            maxWidth: 500,
            margin: 'auto',
        },
    },
    label: {
        color: Colors.GrayDarkest,
        textAlign: 'center',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '100%',
        letterSpacing: 0.48,
    },
    freezeStockContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    freezeEmptyIcon: {
        width: 23,
        height: 22,
    },
    freezeIcon: {
        width: 23,
        height: 22,
    },
});
